export const configuration = {
  serverUrl: "https://api.the-real-insight.ai",
  productionAPIURL: "https://api.the-real-insight.ai",
  mode: "production",
  version: "26.45.0",
  requestTimeout: 120000, // 2 minutes
  jwtConfig: {
    accessTokenExpiry: 5 * 24 * 60 * 60 * 1000, // 5 days in milliseconds
    refreshTokenExpiry: 90 * 24 * 60 * 60 * 1000, // 90 days in milliseconds
    tokenRefreshThreshold: 5 * 60 * 1000, // Refresh token 5 minutes before expiry
  },
  // Stripe configuration - currently disabled in production
  stripeKey:
    "pk_live_51RjYaJP3BYpc5Szh08R6yg6UB6vUal2qWsm57hYT191UB7vjcHvCXGVfLeY8nw4hCGbRjAWvlbX2vbKseIFia5Cu00oQKrLJiL",
  shouldSeeBilling: (authentication: any) => {
    return (
      authentication &&
      authentication.roles &&
      authentication.roles.indexOf("administrator") >= 0
    );
  },
  /** Partner Management: nur dieser Master-Mandant legt Partner an (tri-server PARTNER_MASTER_TENANTS). */
  shouldSeePartnerManagement: (customerID: string) => {
    return customerID === "XI4D-CFWT-7JBS";
  },
  shouldSeeProductManagement: (customerID: string) => {
    return customerID === "XI4D-CFWT-7JBS" || customerID === "S8QW-G8R2-9QLC";
  },
  shouldSeeOperations: (customerID: string) => {
    return customerID === "XI4D-CFWT-7JBS" || customerID === "S8QW-G8R2-9QLC";
  },
  shouldSeeDevelopment: (customerID: string) => {
    return customerID === "XI4D-CFWT-7JBS" || customerID === "S8QW-G8R2-9QLC";
  },
  shouldSeeAdministration: (authentication: any) => {
    return (
      authentication &&
      authentication.roles &&
      authentication.roles.indexOf("root") >= 0
    );
  },
};
